import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-ln-fav-beige-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-fav-beige-svg-icon.component.html',
  styleUrl: './ln-fav-beige-svg-icon.component.css',
})
export class LnFavBeigeSvgIconComponent {
  @Input() class = 'w-8 h-8';
}
